export default {
    billingPage: {
        postageReview: {
            title: 'Invoice Review', invoice: '物流发票号', carrier: '物流商', file: '文件名',
            current: '本次收费金额', total: '客户流水合计', aligned: '一致', mismatch: '不一致',
            no: '序号', customerInvoice: '客户发票 ID', client: '客户编号', charged: '收费金额',
            notInvoiced: '未开票', empty: '暂无关联客户流水', sum: '合计',
            export: '导出 CSV', refresh: '刷新', retry: '重试', close: '关闭',
            error: '核对数据加载失败，请重试。'
        },
        Billing: '账单管理',
            BillingStatusPREVIEW: '待确认',
            BillingStatusPAID: '已付款',
            BillingStatusPARTIAL: '部分付款',
            BillingStatusUNPAID: '未付款',
            BillingStatusOVERPAID: '超额付款',
            BillingStatusDRAFT: '草稿',
            BillingStatusRUNNING: '正式运行',
            BillingStatusSTOP: '已下线',
            zoneGroup: '区域分组',
            Postcode: '邮编数量',
            Updated: '更新人',
            PostcodeS: '起始邮编',
            PostcodeE: '结束邮编',
            DisableDate: '禁用日期',
            searchName: '收费项名称',
            searchID: '按发票编号搜索',
            searchIDs: '按发票编号搜索',
            Status: '状态',
            yearAndWeek: '选择年份和周数',
            yearAndWeeks: '选择年份和周数',
            ApplyWeek: '应用周',
            InvoiceWeek: '开票周',
            yearAndData: '请选择 一条数据 进行生成操作，或者选择 日期 和 客户 进行生成操作',
            Customer: '请选择 客户',
            Customers: '请至少选择一个客户。',
            oney: '只能选择一个 ！',
            description: '描述',
            tag: '标签',
            CreditType: '贷方金额模式',
            creditType: '贷项类型',
            Credit: '贷方金额(不含税)',
            CreditGST: '贷方金额(含税)',
            creditNoe: '生成信用票据',
            creditNote: '信用票据',
        BillingPrice: '客户报价单',
            serviceType: '服务类型',
            price: '单价',
        BillingServiceInvoices: '客户账单',
            totalBalance: '应付款总金额',
            totalBalance1: '总余额',
            totalAvailable1: '总可用余额',
            totalCredit1: '总信用额度',
            totalUnpaid1: '未支付总额',
            downloadInvoice: '下载发票',
            downloadReport: '下载报告',
            invoiceNumber: '发票编号',
            LogisticService: '物流公司',
            TrackingNo: '物流单号',
            Year: '年',
            Week: '周',
            YearWeek: '年/周',
            Date: '日期',
            invoicePrice: '发票价格',
            Paid: '已付款金额',
            Balance: '待付款金额',
        BillingCategories: '收费项',
            create: '新建',
            createTag: '新增标签',
            name: '名称',
            code: '编号',
            Version: '版本',
            effectiveDate: '生效日期',
            state: '状态',
            group: '分组',
            position: '岗位',
            blTip: '比例相加需等于100',
            department: '部门',
            hourlyWage: '岗位时薪',
            Logic: '逻辑',
            run: '启用',
            stop: '停用',
            billingEdit: '收费项编辑',
            billingAdd: '收费项新增',
            billingView: '收费项详情',
            categoryType: '收费项类型',
            categoryCode: '收费项编码',
            categoryName: '收费项名称',
            categoryEnName: '收费项英文名称',
            quotationGroup: '报价组',
            SAPGroup: 'SAP组',
            reportGroup: '报表组',
            Unit: '单位',
            sectionMin: '最小部分',
            sectionMax: '最大部分',
            standardPrice: '标准价格',
            standardCost: '分钟成本',
        BillingProfileTemplates: '收费模版',
            template: '模版',
            templateID: '模版标识',
            profileTemplateName: '模版名称',
            profileTemplateEnName: '模版英文名称',
            ChoseCategories: '选择收费项',
            ChoseProfileTemplate: '选择配置文件',
            lastUpdatedAt: '上次更新时间',
            lastUpdatedBY: '上次更新者',
            usersCount: '用户数量',
            OUTBOUND: '出库',
            STORAGE: '存储',
            Section: '区间',
            Section1: '默认',
            Cost: '成本',
        BillingClientProfiles: '用户收费模版',
            userAccount: '用户账户',
            companyName: '公司名称',
            clientCode: '客户编码',
            index: '序号',
            createdAt: '创建人',
            updateProfile: '更新配置文件',
            createProfile: '创建配置文件',
            boundUser: '用户绑定:',
            billingProfileTemplate: '计费配置文件模板:',
            chargeSection: '收费区间',
            pricing: '定价',
            looseCartonPallet: '松纸箱/托盘',
        BillingTransactions: '计费流水',
            generateType: '生成类型',
            transactionNumber: '交易编号',
            generate: '生成',
            quantity: '数量',
            total: '总价(不含税)',
            createTime: '创建时间',
            transactionDetail: '交易明细',
            transactionForm: '交易信息',
            orderID: '订单ID',
            POID: '采购ID',
            SKUID: '商品ID',
            comments: '备注',
            InternalNotes: '内部记录',
            addInternalNotes: '新增内部记录',
            messages: '消息',
            addmessages: '新增消息',
        BillingPreviewInvoices: '待确认账单',
            companySeller: '客户',
            generateFeeRecords: '生成费用记录',
            generateLastlnvoices: '生成最后发票',
            generatePendingBilling: '生成待确认发票',
            generateBilling: '生成发票并发邮件',
            previewInvoicesNo: '预览发票编号',
            sellerCode: '商家编号',
            totalAmount: '总支付金额',
            batchPDF: '批量下载PDF',
            batchBreakdown: '批量下载Breakdown',
            batchRemove: '去掉最低消费',
            generateContainerPreview: '生成集装箱服务预览发票',
            generateContainerPreviewHint: '生成上周的集装箱服务待确认发票',
            MailProgress: '邮件发送进度',
        BillingInvoices: '发票',
            actions: '批量导出',
            ExportPDF: '导出 PDF',
            ExportCSV: '导出 CSV',
            ExportPMTCSV: '导出 PMT CSV',
            UpdateInvoicePayment: '更新发票付款',
            PaidAmount: '已支付金额',
            InvoicesNo: '发票编号',
            DateOfInvoices: '创建日期',
            dueDate: '截止日期',
            Period: '时间区间',
        BillingAdditionalCharge: '增值服务',
            userName: '客户编码',
            ChargeItem: '收费项',
            Count: '数量',
            Counts: '统计',
            ManualHistory: '手动交易历史记录',
            TotalPrice: '总价',
            YearWeek: '年 / 周',
            Pricing: '定价',
            CreateDate: '创建时间',
            gmtCreate: '交易时间',
            Coments: '描述',
            Submitter: '创建用户',
            Action: '操作',
            Client: '客户企业编号',
            Category: '收费项',
            PurchaseOrder: '采购单号',
            OrderNumber: '订单号',
            ReturnOrder: '退货单号',
            sure: '是否确认保存该条数据？',
            normal: '新增普通费',
            once: '新增处理费',
            oror: '或者',
        BillingRegularSurcharge: '收费策略',
            BasedSource: '服务类型',
            ChargeValue: '收费金额',
            CoverageRate: '收费比例 (%)',
            RegularRules: '常规附加费条例',
            billCategoryCode: '收费项',
            chargeRate: '收费比例',
            startDate: '开始时间',
            endDate: '结束时间',
            EditSurcharge: '编辑常规附加费',
            ACTIVE: '已激活',
            UNACTIVE: '未激活',
        BillingInvoiceStatement: '发票声明',
            CustomerName: '客户名称',
            bpCode: 'BP编号',
            Floating: '浮动利率',
            ratePrice: '浮动运费',
            costPrice: '物流价格',
            send: '发邮件',
            Current: '当前总金额',
            In30Day: '总计30天金额',
            Over30Day: '超过30天的总金额',
            Balances: '代付款金额',
            Email: '计费邮箱',
            Deposit: '保证金',
            Currents: '本期金额',
            In30Days: '30天内金额',
            Over30Days: '超过30天的金额',
        BillingShippingCharges: '运费比较',
            CAMPARE: '物流比较',
            DBFILE: '数据库文件记录',
            HISTORY: '附加费文件记录',
            ImportCSV: '导入CSV 文件',
            ClickImport: '点击导入',
            Carrier: '物流公司',
            InvoiceDate: '发票日期',
            Choose: '选择日期',
            COMPARE: '对比',
            ImportDB: '导入到数据库',
            RecordQty: '记录数量：',
            Rating: '额定价格：',
            Actual: '实际总价：',
            Diff: '差价：',
            TotalDiff: '总差价%：',
            UnMatched: '不匹配的项目：',
            Reference: '参考ID',
            ActualPrice: '实际价格',
            MatchedItems: '匹配的项目：',
            Notes: '订单内部ID',
            Consignment: '托运ID',
            RatingPrice: '评价（带保证金）',
            Difference: '差异',
            DifferencePercent: '差异百分比',
            Surcharge: '附加费事务处理:',
            CHARGE: '索价',
            SurchargeAmount: '附加费金额',
            SurchargeDetail: '附加费明细',
            SurchargeName: '附加费名称',
            IsCharged: '是否收费？',
            FileName: '文件名',
            OperatedDate: '操作时间',
            Operator: '操作员',
            ChargedOrders: '已收费订单',
            Carrie: '物流',
            SurchargedItems: '附加项目',
            SurchargedAmount: '附加运费',
        PostageRecharge: '邮费收费',
            PostageRechargeDetail: '邮费收费详情',
            PostageRechargeCarrier: '物流公司',
            PostageRechargeAllPartners: '全部物流公司',
            PostageRechargeInvoiceNo: '发票编号',
            PostageRechargeSearchInvoice: '搜索发票',
            PostageRechargeNewInvoice: '新建发票',
            PostageRechargeTotalInvoiceAmt: '发票总金额',
            PostageRechargeTotalInvoiceDesc: '当前筛选范围内发票总额',
            PostageRechargeTotalRatePrice: 'API总金额',
            PostageRechargeTotalRateDesc: '当前筛选范围内API金额',
            PostageRechargeTotalUnmatched: '未匹配金额',
            PostageRechargeTotalUnmatchedDesc: '需要处理的金额',
            PostageRechargePendingUploads: '待上传',
            PostageRechargePendingDesc: '缺少发票的物流公司',
            PostageRechargeInvoiceAmt: '发票金额',
            PostageRechargeCollected: '总收费金额',
            PostageRechargeRatePrice: 'API金额',
            PostageRechargeDifference: '差额',
            PostageRechargeUnmatchedPrice: '未匹配金额',
            PostageRechargeAuditDetail: '核对详情',
            PostageRechargeUnmatchedAmount: '未匹配金额',
            PostageRechargeUnmatchedReason: '未匹配原因',
            PostageRechargeReasonPlaceholder: '请输入差异原因',
            PostageRechargeSaveReason: '保存原因',
            PostageRechargeMatchedOrders: '已匹配订单',
            PostageRechargeUnmatchedItems: '未匹配项目',
            PostageRechargeOrderNumber: '订单号',
            PostageRechargeInvoicePrice: '发票金额',
            PostageRechargeTotalChargedPrice: '总收费金额',
            PostageRechargeTotalInvoicePrice: '总发票价格',
            PostageRechargeRate: '费率',
            PostageRechargeRawData: '原始CSV数据',
            PostageRechargeManualMatch: '手动匹配',
            PostageRechargeInvoiceRequired: '发票编号不能为空。',
            PostageRechargeReasonIdRequired: '缺少发票ID，无法保存原因。',
            PostageRechargeUploadTitle: '上传新发票',
            PostageRechargeCarrierOptionsError: '物流商选项加载失败，请点击上传重试。',
            PostageRechargeInvoicePlaceholder: '例如 INV-2024-001',
            PostageRechargeIssueDate: '开票日期',
            PostageRechargeSelectIssueDate: '请选择开票日期',
            PostageRechargeSelectPartner: '请选择物流公司',
            PostageRechargeFinancialAmount: '财务金额',
            PostageRechargeFinancialAmountPlaceholder: '请输入财务金额',
            PostageRechargeUploadFile: '发票文件',
            PostageRechargeUploadPdfFile: '发票 PDF 文件',
            PostageRechargeUploadCsvFile: '发票 CSV 文件',
            PostageRechargeUploadCsvXlsxFile: '发票 CSV / XLSX 文件',
            PostageRechargeDropFile: '将文件拖到此处，或点击上传',
            PostageRechargeUploadTip: '支持 PDF、CSV、XLS、XLSX，最大50MB',
            PostageRechargeUploadPdfTip: '仅支持 PDF，最大50MB',
            PostageRechargeUploadCsvTip: '仅支持 CSV，最大50MB',
            PostageRechargeUploadCsvXlsxTip: '支持 CSV 或 XLSX，最大50MB',
            PostageRechargeUpload: '上传',
            PostageRechargeUploadFileTypeTip: '仅支持 PDF、CSV、XLS、XLSX 文件。',
            PostageRechargeUploadPdfFileTypeTip: '仅支持 PDF 文件。',
            PostageRechargeUploadCsvFileTypeTip: '仅支持 CSV 文件。',
            PostageRechargeUploadCsvXlsxFileTypeTip: '仅支持 CSV 或 XLSX 文件。',
            PostageRechargeUploadSizeTip: '文件大小不能超过50MB。',
            PostageRechargeUploadFileRequired: '请上传发票文件。',
            PostageRechargeUploadPdfFileRequired: '请上传发票 PDF 文件。',
            PostageRechargeUploadCsvFileRequired: '请上传发票 CSV 文件。',
            PostageRechargeUploadCsvXlsxFileRequired: '请上传发票 CSV 或 XLSX 文件。',
            PostageRechargeWeekRequired: '请选择发票周。',
            PostageRechargeManualMatchTitle: '手动项目匹配',
            PostageRechargeTargetItem: '目标未匹配项目',
            PostageRechargeSearchOrder: '搜索订单',
            PostageRechargeSearchOrderPlaceholder: '请输入订单号或物流单号',
            PostageRechargeCurrentSelection: '当前选择',
            PostageRechargeConfirmMatch: '确认匹配',
            PostageRechargeSearchOrderRequired: '请输入搜索关键字。',
            PostageRechargeMatchRequired: '请选择一条物流记录。',
            PostageRechargeInvoiceAmount: '原始发票金额',
            PostageRechargeOrderInvoiceAmount: '发票金额',
            PostageRechargeMatchedAmount: '已匹配金额',
            PostageRechargeCostReceived: '已收成本',
            PostageRechargeAmountReceived: '已收金额',
            PostageRechargeCurrentChargeAmount: '本次收费金额',
            PostageRechargeAverageProfitMargin: '平均利润率',
            PostageRechargeListInvoiceNo: '发票编号',
            PostageRechargeListYearWeek: '年份 / 周',
            PostageRechargeListCarrier: '物流公司',
            PostageRechargeListInvoiceAmount: '原始发票\n金额',
            PostageRechargeListMatchedAmount: '已匹配\n金额',
            PostageRechargeListUnmatchedAmount: '未匹配\n金额',
            PostageRechargeListCostReceived: '已收成本',
            PostageRechargeListAmountReceived: '已收金额',
            PostageRechargeListCurrentChargeAmount: '本次收费\n金额',
            PostageRechargeListAverageProfitMargin: '平均\n利润率',
            PostageRechargeListCreatedTime: '创建时间',
            PostageRechargeOrderCostReceived: '订单已收成本',
            PostageRechargeOrderAmountReceived: '订单已收金额',
            PostageRechargeTotalOrderCost: '订单总成本',
            PostageRechargeCurrentDifference: '本次差额',
            PostageRechargeProfitMargin: '利润率',
            PostageRechargeTrackingNumber: '物流单号',
            PostageRechargeInvoiceOverview: '发票概览',
            PostageRechargeMatchedOrder: '已匹配订单',
            PostageRechargeInvoiceSummaryDesc: '当前筛选范围内的发票总金额',
            PostageRechargeMatchedSummaryDesc: '已成功匹配到订单的金额',
            PostageRechargeUnmatchedSummaryDesc: '需要继续匹配的金额',
            PostageRechargeChargeSummaryDesc: '当前筛选范围内的本次收费金额',
            PostageRechargeMarginSummaryDesc: '已匹配订单的平均利润率',
            PostageRechargeCalculationBreakdown: '计算明细',
            PostageRechargeCalculatedFromOrders: '根据已匹配订单明细计算。',
            PostageRechargeViewOrderBreakdown: '查看订单明细',
            PostageRechargeValidationFailed: '校验失败',
            PostageRechargeExpected: '预期值',
            PostageRechargeActual: '实际值',
            PostageRechargeInvoiceValidationMessage: '原始发票金额不等于已匹配金额与未匹配金额之和。',
            PostageRechargeInvoiceFormulaDesc: '原始物流发票金额的匹配构成。',
            PostageRechargeInvoiceFormula: '原始发票金额 = 已匹配金额 + 未匹配金额',
            PostageRechargeDifferenceFormulaDesc: '已经匹配但尚未处理收费的成本。',
            PostageRechargeDifferenceFormula: '差额 = 已匹配金额 - 已收成本',
            PostageRechargeCurrentDifferenceFormulaDesc: '尚未包含在之前收费中的新增订单成本。',
            PostageRechargeCurrentDifferenceFormula: '本次差额 = 订单总成本 - 订单已收成本',
            PostageRechargeCurrentChargeFormulaDesc: '针对本次成本差额需要收取的金额。',
            PostageRechargeCurrentChargeFormula: '本次收费金额 = 本次差额 /（1 - 利润率）',
            PostageRechargeListChargeFormulaDesc: '所有已匹配订单本次收费金额的合计。',
            PostageRechargeListChargeFormula: '本次收费金额 = 已匹配订单本次收费金额之和',
            PostageRechargeProfitMarginFormulaDesc: '应用本次收费后的利润率。',
            PostageRechargeProfitMarginFormula: '利润率 =（本次收费金额 - 本次差额）/ 本次收费金额',
            PostageRechargeAverageMarginFormulaDesc: '已匹配订单的加权平均利润率。',
            PostageRechargeAverageMarginFormula: '平均利润率 = 已匹配订单利润率的加权平均值',
        BillingStorageReport: '存储报告',
        BillingInvoiceReport: '发票报表',
            // 1 total
            IRclientType: '客户类型',
            IRActive: '有效客户数量',
            IRPallet: '托盘数量',
            IROrder: '订单数量',
            IRPO: '采购订单数量',
            IRReturn: '退货数量',
            IRCMB: 'CBM',
            IRTI: '总收入',
            IRTC: '总成本',
            IRTGP: '总利润',
            IRTPM: '总利润率',
            IRWTI: '每周总收入',
            IRWTC: '每周总成本',
            IRWTGP: '每周总毛利润',
            IRWTPM: '每周总利润率',
            // 2 pallet
            IRTIP: '总收入/托盘',
            IRTCP: '总成本/托盘',
            IRTGPP: '总利润/托盘',
            IRTPMP: '总利润率/托盘',
            IRWTIP: '每周总收入/托盘',
            IRWTCP: '每周总成本/托盘',
            IRWTGPP: '每周总毛利润/托盘',
            IRWTPMP: '每周总利润率/托盘',
            // 3 CBM
            IRTIM: '总收入/CBM',
            IRTCM: '总成本/CBM',
            IRTGPM: '总毛利/CBM',
            IRTPMM: '总利润率/CBM',
            IRWTIM: '每周总收入/CBM',
            IRWTCM: '每周总成本/CBM',
            IRWTGPM: '每周总利润/CBM',
            IRWTPMM: '每周总利润率/CBM',
            // 4 clientqty
            IRNew: '新客户数量',
            IRLeave: '离场客户数量',
            IRWTAC: '每周有效客户总数',
            IRWTNC: '每周新增客户总数',
            IRWTLC: '每周总离场客户',
            // 5 client
            IRClientCode: '客户编码',
            IRtype: '客户类型',
            CBM: 'CBM',
            Postage: '邮费',
            Income: '收入',
            GrossProfit: '利润',
            ProfitMargin: '利润率',
            // 6 postage
            Courier: '快递公司',
            // 7 sales
            Sales: '销售',
            Company: '公司',
        // BusinessBillingOperationLog
            Menu: '菜单',
            Operator2: '操作人',
            Method: '方法',
            Content: '内容',
            OperateTime: '操作时间',

        // BillingDeliveryNote
        OrderInfo: '订单信息',
        OrderIdTip: '请选择订单',
        SellerCode: '请输入卖家标识',
        PalletQty: '托盘数量',
        TotalPalletQty: '托盘总数量',
        WoodenStandardQty: '标准托盘数量',
        ChepPalletQty: 'Chep托盘数量',
        LoscamPalletQty: 'Loscam托盘数量',
        CSGPalletQty: 'CSG托盘的数量',
        ShrinkWrapQty: '收缩包装数量',
        liftOnQty: '提货数量',
        strapWrapQty: '捆扎包装数量',
        LabourTime: '工时',
        Comments: '备注',
        instruction: '要求',
        palletHeight: '托盘高度',
        printLabel: '打印',
        PlaceOrder: '下单',
        PlaceOrderTips: '该物流已被客户禁用，是否确认继续下单？',
        DOWNLOADDELIVERYNOTE: '下载出货通知',
        minText: '分钟',
        NeedEqual: '需要等于',
        PleaseSaveFirst: '请先保存',
        theSameOrDerTip: '所选订单不在同一客户下。',
        // 运费比较
        consignmentNum: '运单号',
        ratedPrice: 'API报价',
        Carrierinvoicetotalprice: '快递公司发票总额',
        difference: '应收差额',
        TotalsurchargedPrice: '已收差额',
        needChargePrice: '需收差额',
        ifNeedCharge: '是否收费',
        MarginRate: '利润率',
        CBM:"CBM",
        customerPallet:"仓库托盘",
        Palletchange: '托盘变更',
        PalletchangeIN: '托盘入库',
        PalletchangeOUT: '托盘出库',
        errTip: '输入数值不能超过已有数值',
        tierName: '档位名称',
        salesTurnoverFrom: '营业额',
        CurrentTier: '报价档位',
        EvaluatedTier: '实际档位',
        CustomerTier: 'Customer Tier',
        // 历史成本
        historicalType: '模板类型',
        historicalBB: 'To B 成本',
        historicalCC: 'To C 成本',
        historicalHis: '历史记录',
        hisGeneral: '一般成本',
        hisTime: '时间成本',
        hisPerce: '时间百分比',
        // 开支管理
        expenseDate:'开支日期',
        expenseLabour:'人员开支',
        expenseExpense:'其他开支',
        expenseWareh:'实际租金',
        expenseManage:'开支管理',
        expenseStart:'开始时间',
        expenseEnd:'结束时间',
        OrderPostagetime: '发票生成时间',
        OrderPostagecreate: '创建时间',
        OrderPostageImportPDF: '导入PDF 文件',
        Amount: '发票金额',
        erpAmount: 'ERP 总金额',
        totalDifference: '总差额',
        customer: '客户',
        timePay: '按时间收费',
        quantityPay: '按数量收费',
        // 钱包
        DEPID:'交易编号',
        DEPAmount:'转账金额',
        DEPTime:'转账时间',
        DEPDetail:'账号详情',
        DEPReference:'转账备注',
        DEPTrans:'账务流水号',
        DEPraw:'信息',
        DEPDes:'转账说明',
        DEPDeposit:'充值',
        DEPsub:'提交',
        DEPAppro:'审核',
        DEPTop:'充值',
        DEPInfo:'支付信息',
        DEPFrom:'付款账户',
        DEPTo:'收款账户',
        DEPScre:'转账截图',
        DEPRemark:'备注',
        MyDepositPage: {
            title: '账户信息',
            Prepay: '充值',
            Balance: '账户余额',
            Available: '可用余额',
            Credit: '信用额度',
            Unpaid: '未支付',
            SecurityBond: '押金',
            tip1: '温馨提示 ： 因订单需完成处理后方可生成费用统计，信息可能略有延迟，具体金额以发票为准，',
            tip2: '最终解释权归CSG公司所有，敬请谅解。',
            tips1: 'Balance',
            tips2: 'Available',
            tips3: 'Credit',
            tips4: 'Unpaid',
            tips5: 'Security Bond',
        },
        source:'源头',
        CApage:'客户账户信息',
        CAemail:'邮箱',
        CAaccount:'账户余额',
        CAaccountF:'账户余额(从)',
        CAaccountT:'账户余额(至)',
        CATime:'更新时间',
        BillingCustomerInventoryPricing:'库存价值',
            InvnetoryValue:'库存金额',
            UnpaidInvoiceAmount:'未结清账单金额',
            DefaultPrice:'默认单价',
            InventoryPrice:'库存单价',
            UnpaidInvoice:'未付账单',
            Healthy:'健康',
            Risky:'风险',
        BusinessBillingCostExpenditureStatistics:'成本支出统计',
            expenseItem:'成本项',
            expenseCategory:'支出类别',
            expensePeriod:'支出周期',
        BillingCostItem:'成本项',
        zoneGroupType: '区域分组类型',
            zoneGroupType1: '普通分区',
            zoneGroupType2: '偏远分区',
            zoneGroupType3: '费率分区',
            zoneType: '分区类型',
            zone: '分区',
            zoneState: '省/州',
            zoneCity: '城市',
            zonePostCode: '邮编',
            zoneCountry: '国家',
    }
};
